import React from 'react';
import { Button } from '@mui/material';
import { openPopupWidget } from 'react-calendly';
var DemoScheduler = function (_a) {
    var buttonLabel = _a.buttonLabel, calendlyEmbedUrl = _a.calendlyEmbedUrl, prefillName = _a.prefillName, prefillEmail = _a.prefillEmail;
    var handleClick = function () {
        openPopupWidget({
            url: calendlyEmbedUrl,
            prefill: {
                name: prefillName,
                email: prefillEmail,
            },
        });
    };
    return (React.createElement("div", null,
        React.createElement(Button, { variant: 'contained', disableElevation: true, onClick: handleClick, sx: { whiteSpace: 'nowrap' } }, buttonLabel)));
};
export default DemoScheduler;
//# sourceMappingURL=DemoScheduler.js.map